<template>
  <div>
    <v-row class="ma-0">
      <strong class="mt-2 mr-2">メールアドレス</strong>
      <v-text-field v-model.trim="keyword" hide-details dense :placeholder="$t('keyword-title')"
        class="max-width-3 mr-3 rounded-xl" outlined @keydown.enter="search" prepend-inner-icon="mdi-magnify"
        autofocus />
      <v-btn color="primary" @click="search">{{ $t("search-title") }}</v-btn>
      <v-spacer />
      <v-btn color="success" @click="dialogCreateUser = true">新規登録</v-btn>
    </v-row>
    <v-layout class="row mx-1 mt-5" child-flex>
      <v-data-table :headers="headers" fixed-header :items="listUser" :loading="loaddingListUser"
        :items-per-page.sync="pagination.maxResultCount" :page="pagination.page" loading-text="読み込み中。。。待ってください。"
        hide-default-footer class="elevation-1">
        <template v-slot:[`item.active`]="{ item }">
          <v-chip small :color="item.active ? 'success' : 'default'" class="text-capitalize font-weight-medium"
            style="min-width: 94px; justify-content: center">{{
                item.active ? $t("active-title") : $t("inactive-title")
            }}</v-chip>
        </template>
        <template v-slot:[`item.email`]="{ item: { email, Id, username } }">
          <router-link :to="{ name: 'Detail user', params: { username: username } }">{{ email ? email : Id }}
          </router-link>
        </template>
        <template v-slot:[`item.last_login`]="{ item }">{{
            item.last_login
              ? $moment(item.last_login).format("YYYY-MM-DD HH:mm")
              : null
        }}</template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn small color="error" v-if="item.active" @click="showDialogConfirmBAN(item)">BAN</v-btn>
        </template>
        <template v-slot:no-data>
          <div class="text-center">データがありません。</div>
        </template>
      </v-data-table>
    </v-layout>
    <v-row class="mx-1 mt-2">
      <strong class="mt-4 mr-2">表示件数</strong>
      <v-select class="max-width-1 mt-2" hide-details :items="recordsPage" v-model="pagination.maxResultCount" dense
        outlined @change="handleChangeResultCount" />
      <v-spacer />
      <BasePagination v-if="pagination.pageCount > 0" class="mt-5" :pageCount="pagination.pageCount"
        :pageSize="pagination.maxResultCount" @changePage="handleChangePage" />
      <DialogCreateUser v-model="dialogCreateUser" @resetList="handleGetListUser" :key="keyDialogCreateUser" />
    </v-row>
    <!-- dialog confirm ban user  -->
    <v-dialog v-model="dialogConfirmBANUser" width="380">
      <v-card>
        <v-card-title class="headline grey lighten-2 py-2">確認</v-card-title>

        <v-card-text class="mt-2">{{
            $t("ban-conten", { name: profileUser.email })
        }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="error" :loading="loaddingBANUser" @click="handleBANUser">OK</v-btn>
          <v-btn small color @click="dialogConfirmBANUser = false">キャンセル</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import mixin from "@/mixin";
import BasePagination from "@/components/Pagination/BasePagination";
import DialogCreateUser from "@/views/ListUser/DialogCreateUser";
import { getListUser, banUser, getListUserCount, search} from "@/api/User.api";
export default {
  mixins: [mixin.App, mixin.Auth],
  components: { BasePagination, DialogCreateUser },
  data() {
    return {
      keyword: "",
      listUser: [],
      loaddingListUser: false,
      dialogCreateUser: false,
      dialogConfirmBANUser: false,
      loaddingBANUser: false,
      keyDialogCreateUser: 0,
      profileUser: {},
      headers: [
        {
          text: "No.",
          align: "start",
          value: "no",
        },
        { text: this.$i18n.t("email-address-title"), value: "email" },
        { text: this.$i18n.t("nickname-title"), value: "nickname" },
        { text: this.$i18n.t("last-login-title"), value: "last_login" },
        { text: this.$i18n.t("approve-title"), value: "active" },
        {
          text: this.$i18n.t("action-title"),
          value: "actions",
          width: "100px",
        },
      ],
      lastEvaluatedKey: [],
      searchResultExists: false,
    };
  },
  watch: {
    dialogCreateUser: function () {
      this.keyDialogCreateUser++;
    },
    "pagination.maxResultCount": function () {
      this.pagination.page = 1;
    },
  },
  created() {
    this.handleGetListUserCount();
    this.handleGetListUser();
  },
  methods: {
    async handleGetListUserCount() {
      const res = await getListUserCount();
      this.pagination.pageCount = res.totalCount;
    },
    async handleGetListUser() {
      this.dialogCreateUser = false;
      this.loaddingListUser = true;
      this.keyDialogCreateUser++;
      const params = {
        limit: this.pagination.maxResultCount,
      };
      await getListUser(params).then((response) => {
        this.listUser = response.result;
        this.listUser.forEach((item, index) => {
          item.no = index + 1;
        });
        if (this.lastEvaluatedKey.findIndex((el) => el.page === 2) === -1) {
          this.lastEvaluatedKey.push({
            page: 2,
            key: response.LastEvaluatedKey,
          });
        }
      });
      this.loaddingListUser = false;
    },
    async handleSearch(value) {
      this.dialogCreateUser = false;
      this.loaddingListUser = true;
      this.keyDialogCreateUser++;
      const params = {
        keyword: value,
      };
      await search(params).then((response) => {
        this.listUser = response.result;
        if (this.lastEvaluatedKey.findIndex((el) => el.page === 2) === -1) {
          this.lastEvaluatedKey.push({
            page: 2,
            key: response.LastEvaluatedKey,
          });
        }
      });
      this.loaddingListUser = false;
    },
    async handleChangeResultCount(value) {
      // オフセット用のキーはリセットする
      this.lastEvaluatedKey = [];
      const params = {
        limit: value,
      };
      try {
        if (this.searchResultExists == true) {
          this.listUser.forEach((item, index) => {
            item.no = index + 1;
          });
        } else {
          const response = await getListUser(params);
          if (response) {
            this.listUser = response.result;
            this.listUser.forEach((item, index) => {
              item.no = index + 1;
            });
            if (this.lastEvaluatedKey.findIndex((el) => el.page === 2) === -1) {
              this.lastEvaluatedKey.push({
                page: 2,
                key: response.LastEvaluatedKey,
              });
            }
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    async handleChangePage(value) {
      // FIXME ２回目以降は取得した情報を参照できるように保持し、繰り返しリクエストしないようにする。
      let offset = this.lastEvaluatedKey.find((el) => el.page == value);
      this.pagination.page = value;
      const params = {
        limit: this.pagination.maxResultCount,
      };

      if (value !== 1) {
        // ページを飛ばした場合キーがわからないため、選択したページの前のページを取得
        if (this.searchResultExists == false) {
          if (!offset) {
            await this.getUserList(value - 1);
            offset = this.lastEvaluatedKey.find((el) => el.page == value);
          }
          params.lastEvaluatedKey = offset.key;
        }
      }
      try {
        if (this.searchResultExists == true) {
          this.listUser.forEach((item, index) => {
            let newIndex = index + 1;
            if((newIndex%this.pagination.maxResultCount)!=0){
              item.no = newIndex%this.pagination.maxResultCount;
            }else{
              item.no = this.pagination.maxResultCount;
            }
          });
        } else {
          const response = await getListUser(params);
          if (response) {
            this.listUser = response.result;
            this.listUser.forEach((item, index) => {
              item.no = index + 1;
            });
            if (
              this.lastEvaluatedKey.findIndex((el) => el.page === value + 1) ===
              -1
            ) {
              this.lastEvaluatedKey.push({
                page: [value + 1],
                key: response.LastEvaluatedKey,
              });
            }
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getUserList(value) {
      if (!this.lastEvaluatedKey.find((el) => el.page == value)) {
        await this.getUserList(value - 1);
      }
      const offset = this.lastEvaluatedKey.find((el) => el.page == value);
      const params = {
        limit: this.pagination.maxResultCount,
      };
      if (value !== 1) {
        params.lastEvaluatedKey = offset.key;
      }
      const response = await getListUser(params);
      if (response) {
        // this.listUser = response.result;
        // this.listUser.forEach((item, index) => {
        //   item.no = index + 1;
        // });
        if (
          this.lastEvaluatedKey.findIndex((el) => el.page === value + 1) === -1
        ) {
          this.lastEvaluatedKey.push({
            page: [value + 1],
            key: response.LastEvaluatedKey,
          });
        }
      }
    },
    async search() {
      const { keyword } = this;
      if (keyword != null && keyword != "") {
        this.searchResultExists = true;
        await this.handleSearch(keyword);
        this.listUser = this.listUser.filter((item) =>
          item.email
            .toString()
            .toLowerCase()
            .includes(keyword.toString().toLowerCase())
        );
        this.listUser.forEach((item, index) => {
          item.no = index + 1;
        });
        this.pagination.pageCount = this.listUser.length;
      } else {
        this.searchResultExists = false;
        await this.handleGetListUserCount();
        await this.handleGetListUser();
      }
      this.pagination.page = 1;
    },
    showDialogConfirmBAN(item) {
      this.profileUser = item;
      this.dialogConfirmBANUser = true;
    },
    async handleBANUser() {
      this.loaddingBANUser = true;
      const { username, Id } = this.profileUser;
      const that = this;
      let checkAccound = username
        .toString()
        .toLowerCase()
        .includes("social".toLowerCase());
      if (checkAccound) {
        this.handleban(username, Id);
      } else {
        await this.handleDisableUser(username)
          .then(async () => {
            this.handleban(username, Id);
          })
          .catch((error) => {
            that.$toast.error(error);
            that.loaddingBANUser = false;
          });
      }
      this.loaddingBANUser = false;
    },
    async handleban(username, id) {
      const that = this;
      let params = {
        username: username.toString(),
        user_id: id,
      };
      console.log("params");
      console.log(params);
      await banUser(params)
        .then(() => {
          that.dialogConfirmBANUser = false;
          that.handleGetListUser();
        })
        .catch((error) => {
          if (error.response.data.result.error == "update error") {
            that.$toast.error("アカウントはBANされている。");
            this.dialogConfirmBANUser = false;
            this.handleGetListUser();
          } else {
            console.log("エラー");
            that.$toast.error(error);
          }
          that.loaddingBANUser = false;
        });
    },
  },
};
</script>

<style lang="sass" scoped></style>
